import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem } from 'primeng/api/selectitem';
import { Chronometer } from 'ngx-chronometer';
import { ModerationService } from 'src/app/services/moderation.service';
import { ContenusService } from 'src/app/services/contenus.service';
import { MessageService } from 'primeng/api';
import { CountdownComponent, CountdownConfig, CountdownEvent } from 'ngx-countdown';
import { config } from 'rxjs';
import { Moderation } from 'src/app/classes/moderation';
import { DateCalculationService } from 'src/app/services/date-calculation.service';
import { EchantillonageService } from 'src/app/services/echantillonage.service';
import { EncryptionService } from 'src/app/services/encryption.service';

@Component({
  selector: 'app-cq',
  templateUrl: './cq.component.html',
  styleUrls: ['./cq.component.css'],
  providers:[MessageService]
})
export class CqComponent implements OnInit,OnDestroy {

  @ViewChild('cd', {static:false}) private countdown : CountdownComponent;
  config : CountdownConfig = {};
  intervalEvent : any;

  user : Object = {};
  detailsPtl : Object = {};
  siteWeb : Object = {};
  description : Object = {};
  logo : Object = {};
  reseauxSociaux : Object[] = [];
  photos : Object[] = [];
  offre : Object = {};
  titreBonPlan : Object =  {};
  phraseAccroche : Object = {};
  detail : object = {};
  koCq : boolean = false;
  attenteDoute: boolean = false;

  idModeration : number;
  validationDescription: boolean;

  showEmailEditor : boolean = false;
  receiverAdress : string = "mtiratay@ancv.fr";
  mailObject : string = "Doute sur la fiche du PTL n° ";
  mailContent: string = "";

  pause: boolean = false;
  selectedPause: string = "";
  pauseItem: SelectItem[] = [
    {label: 'Pause toilette', value: '1'},
    {label: 'Pause déjeuner', value: '2'},
    {label: 'Formation', value: '3'}

  ];


  chrono: Chronometer = new Chronometer();
  chronoPause: Chronometer = new Chronometer();
  chronoNegatif: Chronometer = new Chronometer();
  boolIsNegatif = false;

  disabled : boolean = false;





  constructor(private router: Router, private activatedRoute: ActivatedRoute, private echantillonageService:EchantillonageService, private dateService : DateCalculationService, private encryptService:EncryptionService, private moderationService : ModerationService, private contenuService : ContenusService, private msgService : MessageService) { 
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }
  ngOnDestroy(): void {
    clearInterval(this.intervalEvent);
  }





  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.idModeration = params.moderation;
    });


    this.user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));

    this.moderationService.getDetailsPtl(this.idModeration).subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        
        this.detailsPtl = value["data"];
        this.mailObject = this.mailObject + " " + this.detailsPtl['num_point_accueil'];

        if( (parseInt(this.detailsPtl["id_etat"]) !== 4) && (parseInt(this.detailsPtl["id_etat"]) !== 14) && (parseInt(this.detailsPtl["id_etat"]) !== 18) ) {
          this.router.navigate(['/moderation']);
        }

        if( parseInt(this.detailsPtl["id_responsable_cq"]) !== parseInt(this.user["matricule"]) ) {
          this.navigateNext(0);
        }

        if(this.detailsPtl['id_etat'] === 18) {
          this.attenteDoute = true;
        }

        this.setCountdownOnInit();
      }
    });


    this.contenuService.recupererContenusCq(this.idModeration).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        let input = value["data"];
        
        if(localStorage.getItem("contenus") !== null && localStorage.getItem("contenus") !== undefined) { //=> si il reste une savegarde d'etat (ce qui veut dire que la page a juste rechargée)
          let parsedContents = JSON.parse(localStorage.getItem("contenus"));
          let contenus = parsedContents.contenus;
          let idModeParsed = parseInt(parsedContents.idModeration);

          if(idModeParsed == this.idModeration) {
            this.trierContenus(contenus);
          } else {
            this.trierContenus(input);
          } 
          
        }else {
          this.trierContenus(input);
        }
      }
    });

    this.setChronoOnInit();
  }





  /**
   * Trie les contenus selon leur type pour les placer dans leur variable respectif
   */
  trierContenus(input) {
    input.forEach(current => {
      switch(current.designation_type) {
        case 'lien site web' : {
          this.siteWeb = current;
          break;
        }

        case 'descriptif PTL' : {
          this.description = current;
          break;
        }

        case 'logo' : {
          this.logo = current;
          break;
        }

        case 'lien reseaux sociaux' : {
          this.reseauxSociaux.push(current);
          break;
        }

        case 'photo' : {
          this.photos.push(current);
          break;
        }

        case 'offre bon plan' : {
          this.offre = current;
          break;
        }

        case 'titre bon plan' : {
          this.titreBonPlan = current;
          break;
        }

        case 'phrase accroche' : {
          this.phraseAccroche = current;
          break;
        }

        case 'detail' : {
          this.detail = current;
          break;
        }
      }
    });

  }




  setCountdownOnInit() {
    
    
    switch(parseInt(this.detailsPtl['id_complexite'])) {
      case(1) : {
        this.config = {
          leftTime : 174
        };
        break;
      }

      case(2) : {
        this.config = {
          leftTime : 332
        };
        break;
      }

      case(3) : {
        this.config = {
          leftTime : 590
        };
        break;
      }
    }

    if(localStorage.getItem("countdownCq") !== null) {
      let left = parseInt(localStorage.getItem("countdownCq"));
      this.config = {
        leftTime : left
      };

      if(left < 1) {
        if((localStorage.getItem("countup")) === null || (localStorage.getItem("countup")) === undefined) {
          this.boolIsNegatif = true;
          this.chronoNegatif.second = Math.abs(left);  
          this.chronoNegatif.start();
          localStorage.setItem('countdown', '0');
        } else {
          this.InitValuenegatif();
        }
      }
    }

    
   
    if(this.countdown) {
      this.countdown.begin();
    }
    

    if(!this.boolIsNegatif) {
      this.intervalEvent =  setInterval(() => {
      
        if( this.countdown !== undefined && this.countdown.left === 0)
        {
          this.boolIsNegatif = true;
          this.StartChronoNegatif();
          localStorage.setItem("countdownCq", "0");
        } else if (this.countdown !== undefined) {
          localStorage.setItem("countdownCq", (this.countdown.left / 1000).toString());
        }
  
        
      }, 1000);
    }
    

  }


  onChronoEvent(chronometer: Chronometer) {
    localStorage.setItem("secondCq", chronometer.second.toString());
  }


  /**
   *
   * @param chronometer
   * Stocke la valeur du chrono à chaque seconde (permet de gérer le rechargement de page)
   */
  onChronoEventNegatif(chronometer: Chronometer) {
    //console.log("ChronoNegatif");
    //console.log(chronometer.second.toString());
    localStorage.setItem("countup", chronometer.second.toString());
    //localStorage.setItem("second", chronometer.second.toString());
  }


  /**
   * Initialise le chrono du temps passé
   */
  setChronoOnInit() {
    if(localStorage.getItem("secondCq") !== null) {
      this.chrono.second = parseInt(localStorage.getItem("secondCq"));
    }
    this.chrono.start();
  }







  /**
   * Met à jour la validation du cq pour le composant
   */
  setValidationDescription(value: boolean, forCq : boolean) {
    (forCq) ? this.description["is_valid_cq"] = value : this.description["is_valid"] = value;
    this.saveToLocal();
  }


  /**
   * Met à jour la validation du cq pour le composant
   */
   setValidationTitreBP(value: boolean, forCq : boolean) {
    (forCq) ? this.titreBonPlan["is_valid_cq"] = value : this.titreBonPlan["is_valid"] = value;
    this.saveToLocal();
  }



  /**
   * Met à jour la validation du cq pour le composant
   */
   setValidationPhraseAccroche(value: boolean, forCq : boolean) {
    (forCq) ? this.phraseAccroche["is_valid_cq"] = value : this.phraseAccroche["is_valid"] = value;
    this.saveToLocal();
  }



  /**
   * Met à jour la validation du cq pour le composant
   */
   setValidationDetail(value: boolean, forCq : boolean) {
    (forCq) ? this.detail["is_valid_cq"] = value : this.detail["is_valid"] = value;
    this.saveToLocal();
  }


  /**
   * 
   * @param erreurs 
   * met à jour les motifs de KO de la description
   */
  erreursDescriptionChanged(erreurs: Object[], forCq: boolean) {
    (forCq) ? this.description["erreurs_cq"] = erreurs : this.description["erreurs"] = erreurs;
    this.saveToLocal();
  }


  /**
   * 
   * @param erreurs 
   * met à jour les motifs de KO de la description
   */
   erreursTitreBPChanged(erreurs: Object[], forCq: boolean) {
    (forCq) ? this.titreBonPlan["erreurs_cq"] = erreurs : this.description["erreurs"] = erreurs;
    this.saveToLocal();
  }


  /**
   * 
   * @param erreurs 
   * met à jour les motifs de KO de la description
   */
   erreursPhraseAccrocheChanged(erreurs: Object[], forCq: boolean) {
    (forCq) ? this.phraseAccroche["erreurs_cq"] = erreurs : this.phraseAccroche["erreurs"] = erreurs;
    this.saveToLocal();
  }



  
  /**
   * 
   * @param erreurs 
   * met à jour les motifs de KO de la description
   */
   erreursDetailChanged(erreurs: Object[], forCq: boolean) {
    (forCq) ? this.detail["erreurs_cq"] = erreurs : this.detail["erreurs"] = erreurs;
    this.saveToLocal();
  }




  /**
   * 
   * @param input 
   * @param isLogo //=> vérifie si le composant est un logo ou non
   * Met à jour la valeur is_valid d'un contenu photo ou un contenu logo'
   */
  setMediaValidity(isLogo: boolean, input: Object, forCq : boolean) {
    if(!isLogo) {
      this.photos.forEach(current => {
        if(current["id_contenu"] === input["id_contenu"]){
          (forCq) ? current["is_valid_cq"] = input["is_valid"] : current["is_valid"] = input["is_valid"];
        }
      });
    } else {
      (forCq) ? this.logo["is_valid_cq"]  = input["is_valid"] : this.logo["is_valid"]  = input["is_valid"];
    }
    this.saveToLocal();
  }







  /**
   * 
   * @param input 
   * @param isLogo //=> vérifie si le composant est un logo ou non
   * Met à jour la valeur des motifs d'erreur d'un contenu logo ou photo'
   */
  setMediaErrors(isLogo: boolean, input: Object, forCq : boolean) {
    if(!isLogo) {
      this.photos.forEach(current => {
        if(current["id_contenu"] === input["id_contenu"]){
          (forCq) ? current["erreurs_cq"] = input["erreurs"] : current["erreurs"] = input["erreurs"];
        }
      });
    } else {
      (forCq) ? this.logo["erreurs_cq"]  = input["erreurs"] : this.logo["erreurs"]  = input["erreurs"];
    }
    
    this.saveToLocal();
  }






  /**
   * 
   * @param input 
   * @param isSite //=> vérifie si le composant est un site ou non
   * Met à jour la valeur is_valid d'un contenu site web ou reseaux sociaux'
   */
  setURLValidity(isSite: boolean, input: Object, forCq: boolean) {
    if(!isSite) {
      this.reseauxSociaux.forEach(current => {
        if(current["id_contenu"] === input["id_contenu"]){
          (forCq) ? current["is_valid_cq"] = input["is_valid"] : current["is_valid"] = input["is_valid"];
        }
      });
    } else {
        (forCq) ? this.siteWeb["is_valid_cq"]  = input["is_valid"] : this.siteWeb["is_valid"]  = input["is_valid"];
    }

    this.saveToLocal();
  }






  /**
   * 
   * @param input 
   * @param isSite //=> vérifie si le composant est un site ou non
   * Met à jour la valeur des motifs d'erreur d'un contenu site web ou reseaux sociaux'
   */
  setURLErrors(isSite: boolean, input: Object, forCq : boolean) {
    if(!isSite) {
      this.reseauxSociaux.forEach(current => {
        if(current["id_contenu"] === input["id_contenu"]){
          (forCq) ? current["erreurs_cq"] = input["erreurs"] : current["erreurs"] = input["erreurs"];
        }
      });
    } else {
        (forCq) ? this.siteWeb["erreurs_cq"]  = input["erreurs"] : this.siteWeb["erreurs"]  = input["erreurs"];
    }
    
    this.saveToLocal();
  }




 /**
   * Cette fonction retourne un tableau rassemblant tous les contenus et leur etat actuel
   */
  assemblerContenus() : any[] {
    let options = [];
    
    if(this.siteWeb.hasOwnProperty("id_contenu")) options.push(this.siteWeb);
    if(this.logo.hasOwnProperty("id_contenu")) options.push(this.logo);
    if(this.description.hasOwnProperty("id_contenu")) options.push(this.description);   
    if(this.titreBonPlan.hasOwnProperty("id_contenu")) options.push(this.titreBonPlan);
    if(this.detail.hasOwnProperty("id_contenu")) options.push(this.detail);
    if(this.phraseAccroche.hasOwnProperty("id_contenu")) options.push(this.phraseAccroche); 

    if(this.reseauxSociaux.length > 0) {
      this.reseauxSociaux.forEach(current => {
        options.push(current);
      });
    }

    if(this.photos.length > 0) {
      this.photos.forEach(current => {
        options.push(current);
      });
    }

    return options;
  } 




  /**
   * Recherche  le prochain ptl à traiter
   * @param idAction 
   * @param quitter 
   */
  nextTraitement(idAction : number , quitter:boolean=false) {
    this.disabled = true;
    let mode = localStorage.getItem("mode");
    
    let options = [];
    options.push(this.siteWeb);
    options.push(this.logo);
    options.push(this.description);
    options.push(this.titreBonPlan);
    options.push(this.phraseAccroche);
    options.push(this.detail);

    this.reseauxSociaux.forEach(current => {
      options.push(current);
    });

    this.photos.forEach(current => {
      options.push(current);
    });


    let isOk = true;
        
    if(idAction !== 9 && idAction !== 10) isOk = this.checkContenus(options); //=> si pas d'enregistrement 
    
    if(idAction === 10) this.koCq = true;
    
    if(isOk) {
      let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
      let parameter = {
        'idModeration' : this.idModeration,
        'operateur' : user.matricule,
        'action' : idAction,
        'contenus' : options,
        "duree" : this.chrono.second,
        "is_ok" : !this.koCq,
        "etat" : this.detailsPtl["id_etat"]
      };
      //let raw = String.raw`${JSON.stringify(parameter)}`;

      this.contenuService.validerTraitement(parameter).subscribe(value => {
        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + value["cause"]);
          alert("Une erreur s'est produite, veuillez réessayer");
          this.disabled = false;
        }else {
          this.chrono.pause();
          clearInterval(this.intervalEvent);
          localStorage.removeItem("secondCq");
          localStorage.removeItem("countdownCq");
          localStorage.removeItem("contenus");
          
          if(quitter !== true ){
            this.navigateNext(idAction);
          } else {
            if(this.detailsPtl['id_type_echantillonage'] === 2) {
              this.router.navigate(['/echantillonage']);
            } else  {
              this.router.navigate(['/moderation']);
            }
          }
        }
      });
    } else {
      this.disabled = false;
    }

  }








  /**
   * Permet de naviguer une fois le traitement fini ou si le ptl n'appartient pas à l'opérateur 
   */
  navigateNext(idAction : number) {
    let mode = localStorage.getItem("mode");
   

    if(idAction === 9 ) { //si on fait un enregistrement simple on est redirigé vers une autre page
      this.router.navigate(["/historique"]);
    } else if(this.detailsPtl['id_type_echantillonage'] === 2) {

      this.echantillonageService.getFiltres().subscribe( value => {
        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + value["cause"]);
        }else {
          let listeFiltre = value['data'];
          let sortie = this.setFiltres(listeFiltre);
          let complexites = this.arrayToString(sortie.complexiteSelected);
          let operateurs = this.arrayToString(sortie.opSelected);
          
          this.echantillonageService.filtrerFiches(sortie.contenuSelected,complexites,operateurs).subscribe( value => {
            if(value["status"] !== "success"){
              console.log("Une erreur dans la requête:" + value["cause"]);
            }else {
              let liste = value['data'];
              let op = (sortie.opSelected.length > 0) ? true : false;
              let contenu = (sortie.contenuSelected.length > 0) ? true : false;
              let complexite =(sortie.complexiteSelected.length > 0) ? true : false;
              this.routeToNextDispoCible(liste, 0, op, contenu, complexite);
            }
          });
        }
      });


    } else {

        this.moderationService.getPtlEnAttenteCq().subscribe((value) => {
          if(value["status"] !== "success"){
            console.log("Une erreur dans la requête:" + value["cause"]);
          }else {
            let moderations : Moderation[] = [];
            let moderationList = value["data"];
            moderations = this.formatArray(moderationList);
            moderations.sort(this.sortByDuree);

            if(moderations.length > 0) { //=> si on a des modération à faire
              this.routeToNextDispo(moderations, 0);
            } else {
              this.router.navigate(['/moderation']);
            }
          }
        });



    }
    

  }



  setFiltres(liste:any[]) {
    let sortie = {
      contenuSelected : [],
      opSelected : [],
      complexiteSelected : []
    };
    liste.forEach( current => {
      let valeur:string = current.valeur_filtre;
      let splitted:any[] = valeur.split(',');
      
      splitted.forEach( currentSplitted => {
        switch( parseInt(current.id_filtre)) {

          case(1) : {
            if(currentSplitted !== '') {
              currentSplitted = parseInt(currentSplitted);
              sortie.contenuSelected.push(currentSplitted);
            }
            
            break;
          }
  
          case(2) : {
            if(currentSplitted !== '') {
              currentSplitted = parseInt(currentSplitted);
              sortie.opSelected.push(currentSplitted);
            }
            
            break;
          }
  
          case(3) : {
            if(currentSplitted !== '') {
              currentSplitted = parseInt(currentSplitted);
              sortie.complexiteSelected.push(currentSplitted);
            }
            
            break;
          }
  
        }
      });
    });

    return sortie;

  }



  arrayToString(arrayIn : any[]) {
    let out = ''
    arrayIn.forEach(current => {
      out += (out === '') ? current : ',' + current;
    });
    return out;
  }



  /**
   * fonction recursif de parcours de la liste des PTL elligible pour l'échantillonage ciblée
   * Tans que le ptl est déjà pris on avance dans la liste
   * @param moderationListe 
   * @param index 
   */
  routeToNextDispoCible(moderations : Moderation[], index: number, op:boolean,contenu:boolean,complexite:boolean){
    if(index >= moderations.length) {
      this.router.navigate(['/echantillonage']);
    } else {
          let options = {
            moderation : moderations[index]['id_moderation'],
            operateur : this.user["matricule"],
            action : 4,
            etat : 5
          };

          
          this.echantillonageService.setEchantillonageSurFiche(options.moderation,op,contenu,complexite).subscribe(value => {
            if(value["status"] !== "success"){
              console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
              if(value["cause"] === "PTL déjà pris" || value["cause"] === "PTL déjà livré") {
                this.routeToNextDispoCible(moderations, (index + 1), op, contenu, complexite);
              }
            } else {
              
              this.moderationService.changerEtat(options).subscribe(value => {
                if(value["status"] !== "success"){
                  console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
                  if(value["cause"] === "PTL déjà pris" || value["cause"] === "PTL déjà livré") {
                    //this.routeToNextDispoCible(moderations, (index + 1));
                    console.log('PTL pris');
                  }
                } else {
                  this.router.navigate(["/cq", moderations[index].idModeration] );
                }
              });

            } 
          });
    }
  }


  /**
   * fonction recursif de parcours de la liste de modération en entrée
   * Tans que le ptl est déjà pris on avance dans la liste
   * @param moderationListe 
   * @param index 
   */
  routeToNextDispo(moderations : Moderation[], index: number){
    if(index >= moderations.length) {
      this.router.navigate(['/moderation']);
    } else {
      let options = {
        moderation : moderations[index].idModeration,
        operateur : this.user["matricule"],
        action : 4,
        etat : moderations[index].idEtat
      };
  
      if(options.etat === 13) {
        this.routeToNextDispo(moderations, (index + 1));
      } else {
        this.moderationService.changerEtat(options).subscribe(value => {
          if(value["status"] !== "success"){
            console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
            if(value["cause"] === "PTL déjà pris") {
              this.routeToNextDispo(moderations, (index + 1));
            }
          } else {
            this.router.navigate(["/cq", moderations[0].idModeration] );
          }
        });
      }
    }
  }


  /**
   * Cette fonction permet de formatter le tableaux retourné par l'api en format utilisable pour le tableau
   * type => 1: moderation, 2 : cq
   * @param moderationList 
   */
  formatArray(moderationList : any[]) {
    let cumulArray : Moderation[] = [];

    moderationList.forEach(item => {
      let dateDelai: Date ;
      let now:Date = new Date();
      let delaiRestant:string;
      
      if(item.type_ptl === "INITIALE") {
        dateDelai = this.dateService.calculDelay(item.date_arrivee, 24);
      } else {
        dateDelai = this.dateService.calculDelay(item.date_arrivee, 2);
      }
      
      if(now.getTime() > dateDelai.getTime()){
        delaiRestant = "00:00";
      }else {
        delaiRestant = this.dateService.getDifference(now, dateDelai);
      }

      let mod : Moderation = {
        idModeration : item.id_moderation,
        numPointAccueil : item.num_point_accueil,
        numConvention : item.num_convention,
        numEncaisseur : item.num_encaisseur,
        typePtl : item.type_ptl,
        operateur : item.operateur,
        idBonPlan : item.id_bon_plan,
        responsableCq : item.id_responsable_cq,
        etat : item.etat,
        tempsRestant : delaiRestant,
        idEtat : item.id_etat,
        priorite : item.priorite,
        idComplexite : item.id_complexite,
        complexite : item.libelle_complexite
      };

      cumulArray.push(mod);
    });

    return cumulArray;
  }


  /**
   * Ordre des fiches par durée
   */
  sortByDuree(a : Moderation, b : Moderation) {
    if(a.tempsRestant > b.tempsRestant ) {
      return 1;
    } else if (a.tempsRestant < b.tempsRestant ){
      return -1;
    } else {
      return 0;
    }
  }



  /**
   * Annulation traitement
   */
  annulerTraitement() {
    this.disabled = true;
    let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));

    let options = {
      moderation : this.idModeration,
      operateur : user.matricule,
      action : 6,
      etat : this.detailsPtl['id_etat'],
      typeAction : 5,
      typePtl : this.detailsPtl['id_type_ptl']
    };

    this.moderationService.annulerTraitement(options).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
        this.disabled = false;
      } else {
        clearInterval(this.intervalEvent);
        localStorage.removeItem("secondCq");
        localStorage.removeItem("contenus");
        localStorage.removeItem("countdownCq");
        this.router.navigate(["/moderation"]);
      }
    });
  }





  /**
   * Fonctions pour la pause
   */
  beginPause(){
    this.pause = true;
    this.chrono.pause();
    this.countdown.pause();
    this.chronoPause.start();
  }

  endPause(){
    this.pause = false;
    this.chrono.start()
    this.countdown.resume();
    this.chronoPause.pause();
    this.selectedPause= "";
    this.chronoPause.stop();
  }

  endPauseClickable() {
    if(this.pause === true && this.selectedPause !== ""){
      return false;
    }
    return true;
  }




  /**
   * Vérifie si les contenus sont bons (les KO avec motifs et pas de contenus non traité)
   */
  checkContenus(contenus : any[] ) : boolean {
    let result = true;

    contenus.forEach(currentContenu => {
        if(currentContenu.is_valid_cq === null || currentContenu.is_valid === null) {
          result = false;
          this.errorContenu(currentContenu, "Non passé par CQ");
        }else if(currentContenu.is_valid_cq === false) {
          /* if( !currentContenu["erreurs_cq"] || currentContenu["erreurs_cq"].length === 0) {
            result = false;
            this.errorContenu(currentContenu, "KO mais sans motif");
          } */
          this.koCq = true;

        } else if (currentContenu.is_valid === false) {
          if( !currentContenu["erreurs"] || currentContenu["erreurs"].length === 0) {
            result = false;
            this.errorContenu(currentContenu, "KO mais sans motif");
          }
        }
    });

    return result;
  }






  errorContenu(contenu : Object , detail: string) {
    this.msgService.add({
      severity:'error',
      summary:'Contenu de type ' + contenu["designation_type"] + " : " + detail,
      detail: 'Contenu : ' + contenu["valeur_contenu"] 
    })
  }
  



  /**
   * Sauvegarde l'etat de la fiche dans le localstorage pour prévenir des recharges de page
   */
  saveToLocal() {
    let contenus = this.assemblerContenus();
    let stringified = {
      idModeration : this.idModeration,
      contenus : contenus
    }

    localStorage.setItem('contenus', JSON.stringify(stringified));
  }




  /**
   * Fonction d'envoi de mail
   * @param options
   */
  sendMail() {
    let options = {};
    options['receiver'] = this.receiverAdress;
    options['objet'] = this.mailObject;
    options['contenu'] = this.mailContent;

    console.log(this.mailContent)
    this.contenuService.envoyerMail(options).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
      } else {
        this.showEmailEditor = false;
        this.mailContent ="";
        this.nextTraitement(10);
      }
    }); 
  }


  showEditor() {
    this.showEmailEditor = true;
  }




  /**
   * Fonction qui change le statut du doute
   * @param input 
   */
  contenuDouteUpdated(input : Object) {

    switch(input['type']) {

      case('description') : {
        this.description['doute'] = input["doute"];
        break;
      }

      case('site') : {
        this.siteWeb['doute'] = input['doute'];
        break;
      }

      case('logo') : {
        this.logo['doute'] = input['doute'];
        break;
      }


      case('titreBonPlan') : {
        this.titreBonPlan['doute'] = input['doute'];
        break;
      }

      case('phraseAccroche') : {
        this.phraseAccroche['doute'] = input['doute'];
        break;
      }

      case('detail') : {
        this.detail['doute'] = input['doute'];
        break;
      }

      case('photo') : {
        this.photos.forEach( photo => {
          if(photo["numero_contenu"] === input['numContenu']) {
            photo['doute'] = input['doute'];
          }
        });

        break;
      }


      case('reseaux') : {

        this.reseauxSociaux.forEach(rs => {
          if(rs['numero_contenu'] === input['numContenu']) {
            rs['doute'] = input['doute'];
            
          }
        });

        break;
      }


    }

    this.saveToLocal();

  }



  verifierEnseigne () {
    let contenu = this.detailsPtl["enseigne_guide"];
    contenu = "https://www.google.com/search?q=" + escape(contenu);
    contenu = contenu.replace(/%u0153/g, 'oe');
    contenu = contenu.replace(/%u2019/g, '\'');
    //var url = encodeURI(contenu);
    window.open(contenu, "_blank");
  }

  getIfRetour() {
    return (parseInt(this.detailsPtl['id_type_ptl']) === 1) ? false : true;
  }


  // FOnction Lancement Negatif
  StartChronoNegatif()
  {
    this.chronoNegatif.start();
  }

  // Fonction Initialisation Donnee LocalStorage Negatif
  InitValuenegatif()
  {
      let left = (localStorage.getItem('countdownCq')) ? parseInt(localStorage.getItem("countdownCq")) : 0;
      console.log("INIt"+left);
      if(localStorage.getItem("countdownCq") === null ) {
        left = 1;
        this.countdown.left = 1;
      }
      if(left === 0)
      {
        this.boolIsNegatif = true;
        if(localStorage.getItem("secondCq") !== null) {
          this.chronoNegatif.second = parseInt(localStorage.getItem("countup"));
        }
        this.chronoNegatif.start();
      }
  }

}
